import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { version } from './version'

// Only initialize Sentry in production environments
if (
  process.env.NODE_ENV === 'production' ||
  process.env.REACT_APP_ENABLE_SENTRY === 'true'
) {
  Sentry.init({
    dsn: 'https://a68a0773105dc6f290cb896e5979cea5@o206202.ingest.us.sentry.io/4509640498806785',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  })
  console.log('%c[Sentry] Initialized', 'color: #FFA500')
} else {
  console.log('%c[Sentry] Disabled in development', 'color: #6B7280')
}

// Log version on every page load
console.log(`%c[App Version] ${version}`, 'color: #31C48D')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

reportWebVitals()
